

export default class AnimationResponse  {
	Id: string = '';
	Name?: string = '';
	Url?: string = '';
	constructor(obj?: Partial<AnimationResponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
